<template>
  <div class="addAddress absolute">
    <div class="default acea-row row-middle">
      <div class="select-btn">
        <div class="checkbox-wrapper d-i-b mr-2">
          <label class="well-check">
            <input type="radio" value="1" @click="changeInvoiceType(1)" :checked="invoice_type == 1" />
            <i class="icon"></i><span class="def">个人开票</span></label>
        </div>
        <div class="checkbox-wrapper d-i-b mr-2">
          <label class="well-check">
            <input type="radio" value="2" @click="changeInvoiceType(2)" :checked="invoice_type == 2"/>
            <i class="icon"></i><span class="def">企业开票</span></label>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">姓名</div>
        <input
            type="text"
            placeholder="请输入开票姓名"
            v-model="invoice_real_name"
            required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">邮箱</div>
        <input
            type="text"
            placeholder="请输入接收邮箱"
            v-model="email"
            required
        />
      </div>
      <div class="item acea-row row-between-wrapper" v-show="invoice_type == 2">
        <div class="name">公司名</div>
        <input
            type="text"
            placeholder="请输入开票公司名"
            v-model="company_name"
            required
        />
      </div>
      <div class="item acea-row row-between-wrapper" v-show="invoice_type == 2">
        <div class="name">公司税号</div>
        <input
            type="text"
            placeholder="请输入公司税号"
            v-model="invoice_code"
            required
        />
      </div>
    </div>
    <div></div>
    <div class="keepBnt bg-color-red mt-2" @click="confirm">申请开票</div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import { required, chs, email } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { latestInvoice, applyInvoice } from "@api/order";

export default {
  name: "ApplyInvoice",
  components: {},
  props: {},
  data: function() {
    return {
      email: "",
      invoice_real_name: "",
      invoice_type: 1,
      invoice_code: "",
      company_name: "",
      relation_id: this.$route.params.id
    };
  },
  computed: mapGetters(["userInfo"]),
  mounted: function() {
    let that = this;
    // 最近的开票信息
    latestInvoice().then(res => {
      if (res.data != undefined && res.data.id != undefined) {
        that.email = res.data.email;
        that.invoice_real_name = res.data.invoice_real_name;
        that.invoice_type = res.data.invoice_type;
        that.company_name = res.data.company_name;
        that.invoice_code = res.data.invoice_code;
      }
    });
  },
  methods: {
    changeInvoiceType(val) {
      this.invoice_type = val;
    },
    async confirm() {
      let that = this;

      const form_data = {
        invoice_type: that.invoice_type,
        invoice_real_name: that.invoice_real_name,
        email: that.email,
        company_name: that.company_name,
        invoice_code: that.invoice_code,
        relation_id: that.relation_id,
        relation_order_id: that.relation_order_id
      };

      let valid_rules = {
        invoice_real_name: [
          required(required.message("开票姓名")),
          chs(chs.message("开票姓名"))
        ],
        email: [
          required(required.message("邮箱")),
          email(email.message("邮箱"))
        ]
      };
      if (form_data.invoice_type == 2) {
        valid_rules = {
          invoice_real_name: [
            required(required.message("开票姓名")),
            chs(chs.message("开票姓名"))
          ],
          email: [
            required(required.message("邮箱")),
            email(email.message("邮箱"))
          ],
          company_name: [required(required.message("开票公司"))],
          invoice_code: [required(required.message("公司税号"))]
        };
      }

      try {
        await that.$validator(valid_rules).validate(form_data);
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      // 申请开票
      applyInvoice(form_data)
        .then(res => {
          that.$dialog.success(res.msg).then(() => {
            that.$router.replace({ name: "MyOrder" });
          });
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script>
<style scoped>
.d-i-b{display: inline-block}
.mr-2{margin-right: .56rem}
.mt-2{margin-top:.56rem}
</style>
